import React from 'react';
import { NavGroupData } from './useNavGroups';
import NavItem from './NavItem';

interface NavGroupProps {
  group: NavGroupData;
  isCollapsed: boolean;
  activeRoute: string | null;
  onItemClick: (route: string | null) => void;
}

/**
 * NavGroup — A group of navigation items in the left rail.
 *
 * Displays a group label (when expanded) and a list of NavItem components.
 */
export default function NavGroup({ group, isCollapsed, activeRoute, onItemClick }: NavGroupProps) {
  return (
    <div className="mb-2">
      {/* Group label - hidden when collapsed */}
      {!isCollapsed && (
        <h3 className="px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[var(--color-text-dim)]">
          {group.label}
        </h3>
      )}

      {/* Group items */}
      <div className="space-y-0.5">
        {group.items.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            isActive={item.route === activeRoute}
            isCollapsed={isCollapsed}
            onClick={() => onItemClick(item.route)}
          />
        ))}
      </div>
    </div>
  );
}
